import React from 'react';
import { List, ListItem, ListItemAvatar, Avatar, ListItemText, Typography, Paper, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useChat } from './ChatContext';
import { useSelector } from 'react-redux';

const ChatList: React.FC = () => {
    const { activeChats, setCurrentChat, isChatOpen, setIsChatOpen, currentChat } = useChat();
    const user = useSelector((state: any) => state.user.user);

    if (!isChatOpen || currentChat) return null;

    return (
        <Paper
            elevation={3}
            sx={{
                position: 'fixed',
                bottom: 80,
                right: 20,
                width: 300,
                height: 400,
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1000,
                overflow: 'hidden'
            }}
        >
            <Box sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'primary.main', color: 'white' }}>
                <Typography variant="h6">Conversas</Typography>
                <IconButton size="small" onClick={() => setIsChatOpen(false)} sx={{ color: 'white' }}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <List sx={{ flexGrow: 1, overflowY: 'auto' }}>
                {activeChats.length === 0 ? (
                    <Typography variant="body2" sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
                        Nenhuma conversa iniciada.
                    </Typography>
                ) : (
                    activeChats.map((chat) => {
                        const otherUser = chat.senderId._id === user._id ? chat.receiverId : chat.senderId;
                        const lastMessage = chat.messages[chat.messages.length - 1];

                        return (
                            <ListItem
                                button
                                key={chat._id}
                                onClick={() => setCurrentChat(chat)}
                                alignItems="flex-start"
                            >
                                <ListItemAvatar>
                                    <Avatar alt={otherUser.name} src={otherUser.image} />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={otherUser.name}
                                    secondary={
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            {lastMessage ? (lastMessage.text.length > 20 ? lastMessage.text.substring(0, 20) + '...' : lastMessage.text) : 'Inicie a conversa'}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        );
                    })
                )}
            </List>
        </Paper>
    );
};

export default ChatList;
